import React, { useMemo } from "react";
import { LineSeperator } from "../../../../components/RegularComponents";

export const WorkHistoryTab = (props) => {

    const { appData } = props;
    const { workHistoryData } = appData
    return (
        <div style={{marginTop: "1em"}}>
            {workHistoryData?.map((workHistoryItem, index) => (
                <div key={index}>
                    <DetailSection workHistoryItem={workHistoryItem} />
                    <LineSeperator />
                </div>
            ))}
        </div>
    )
}

const DetailSection = ({ workHistoryItem }) => {
    const person = useMemo(() => {
        return `${workHistoryItem.people.firstName} ${workHistoryItem.people.lastName}`
    }, [workHistoryItem])
    return (
        <>
        {/* Name */}
        <div className="row">
            <div className="collector-licence-col col-md-4" style={{ flexGrow: 1, display: "flex", fontWeight: "bold" }}>
                <span>Name</span>
            </div>

            <div className="collector-licence-col col-md-6" style={{ display: "flex" }}>
                {person}
            </div>
        </div>
        {/* Date of offence */}
        <div className="row section-row-margin">
            <div className="collector-licence-col col-md-4" style={{ flexGrow: 1, display: "flex", fontWeight: "bold" }}>
                <span>Work history</span>
            </div>

            <div className="collector-licence-col col-md-6" style={{ display: "flex" }}>
                {workHistoryItem.description}
            </div>
        </div>
        </>
    )
}